const { m } = require('minthril');

function NotFoundPage() {
  return {
    view: () => m('section.not-found',
      m('p.products__eyebrow', '404'),
      m('h1', 'Page not found'),
      m('p', 'This part of the catalogue does not exist.'),
      m('a', { href: '/products' }, 'Back to parts →')
    )
  };
}

module.exports = { NotFoundPage };
